import styled from '@emotion/styled';

import { createElement } from 'react';

const ButtonComponent = ({ tag, buttonRef, children, ...props }) =>
	createElement(tag, { ...props, ref: buttonRef }, children);

export const Button = styled(ButtonComponent)`
	position: relative;
	overflow: hidden;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	cursor: pointer;
	flex-direction: row;
	text-decoration: none;
	border-width: 1px;
	border-style: solid;
	border-radius: var(--small-border-radius);
	justify-content: center;
	font-size: var(--paragraph3-font-size);
	gap: 0.5rem;
	width: max-content;

	&.rightIcon {
		flex-direction: row-reverse;
	}

	&.xx-small {
		padding: var(--buttonXXsmallPadding);
	}
	&.x-small {
		padding: var(--buttonXsmallPadding);
	}
	&.small {
		padding: var(--buttonSmallPadding);
	}
	&.medium {
		padding: var(--buttonMediumPadding);
	}
	&.large {
		padding: var(--buttonLargePadding);
	}
	&.x-large {
		padding: var(--buttonXLargePadding);
	}
	&.xx-large {
		padding: var(--buttonXXLargePadding);
	}

	&.solid {
		background: ${({ color }) => color};
		border-color: ${({ color }) => color};
		color: var(--white);

		:not(.disabled):hover {
			filter: brightness(1.2);
		}

		.button-text,
		.button-icon {
			color: var(--alwaysWhiteColor);
		}
	}

	&.text {
		background: var(--textButtonBgColor);
		border-color: transparent;
		color: ${({ color }) => color};

		:not(.disabled):hover {
			background: var(--textButtonBgHoverColor);
			color: var(--blue-hover);

			.button-text,
			.button-icon {
				color: ${({ color }) => color};
				filter: brightness(1.2);
			}
		}

		.button-text,
		.button-icon {
			color: ${({ color }) => color};
		}
	}

	&.transparent {
		background: transparent;
		border-color: transparent;
		color: ${({ color }) => color};

		:not(.disabled):hover {
			background: var(--actionButtonColor);
			color: var(--blue-hover);

			.button-text,
			.button-icon {
				color: ${({ color }) => color};
				filter: brightness(1.2);
			}
		}

		.button-text,
		.button-icon {
			color: ${({ color }) => color};
		}
	}

	&.blue {
		background: var(--blue);
		border-color: var(--blue);
		color: var(--alwaysWhiteColor);

		:not(.disabled):hover {
			background: var(--blue-hover);
		}

		.button-text,
		.button-icon {
			color: var(--alwaysWhiteColor);
		}
	}
	&.outline {
		background: var(--outlineButtonColor);
		border-color: var(--blue);
		color: var(--blue);

		:not(.disabled):hover {
			background: var(--blue-hover);
			color: var(--white);

			.button-text,
			.button-icon {
				color: var(--alwaysWhiteColor);
			}
		}

		.button-text,
		.button-icon {
			color: var(--blue);
		}
	}
	&.black {
		background: var(--secondaryColor);
		border-color: transparent;
		color: var(--alwaysWhiteColor);

		:not(.disabled):hover {
			background: var(--secondaryColor);
		}

		.button-text,
		.button-icon {
			color: var(--alwaysWhiteColor);
		}
	}
	&.blackOutline {
		background: transparent;
		border-color: var(--black);
		color: var(--black);

		:not(.disabled):hover {
			background: var(--black);
			color: var(--white);

			.button-text,
			.button-icon {
				color: var(--white);
			}
		}
	}
	&.blueBorderless {
		background: transparent;
		border-color: transparent;
		color: var(--blue);

		:not(.disabled):hover {
			background: var(--actionButtonColor);
			color: var(--blue-hover);

			.button-text,
			.button-icon {
				color: var(--blue);
			}
		}

		.button-text,
		.button-icon {
			color: var(--blue);
		}
	}
	&.action {
		background: var(--actionButtonColor);
		border-color: transparent;
		color: var(--black);

		:not(.disabled):hover {
			background: var(--actionButtonHoverColor);

			.button-text,
			.button-icon {
				color: var(--black);
			}
		}
	}
	&.borderless {
		background: transparent;
		border-color: transparent;
		color: var(--black);
		cursor: pointer;

		:not(.disabled):hover {
			background: rgb(0 0 0 / 5%);
			color: var(--black);

			.button-text,
			.button-icon {
				color: var(--black);
			}
		}
	}

	&.disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}

	&.iconButton {
		border-radius: 50%;

		&.xx-small {
			width: 1.6rem;
			height: 1.6rem;
		}
		&.x-small {
			width: 2rem;
			height: 2rem;
		}
		&.small {
			width: 3rem;
			height: 3rem;
		}
		&.medium {
			width: 4rem;
			height: 4rem;
		}
		&.large {
			width: 5rem;
			height: 5rem;
		}
	}

	&.fullWidth {
		width: 100%;
	}

	> span.ink {
		display: block;
		position: absolute;
		background: rgba(255, 255, 255, 0.3);
		border-radius: 100%;
		transform: scale(0);

		&.animate {
			animation: ripple 650ms linear;
			animation-fill-mode: forwards;
		}
		&.animate-out {
			animation-fill-mode: none;
		}
	}

	@keyframes ripple {
		100% {
			opacity: 0.5;
			transform: scale(2.5);
		}
	}

	&.lord-icon {
		width: 10rem !important;
		height: 10rem !important;
	}
`;
